<template>
  <div class="video-library">


    <div class="banner-text-box">
      <!-- <h2 class="how-heading">How it works ?</h2> -->
      <p class="how-desc">
        For caregivers, the platform is always 100% free - because women who’ve already given so much shouldn’t have to
        pay to give more. For families, it’s just $49 for three months (then $6.70 a month) to browse trusted,
        experienced women in your community, connect directly, and organise care in a way that suits your household. No
        inflated fees, no lock-ins - just flexible, affordable support built on real human connection.
        Instead of relying on a patchy system of governance and outdated assurances, we believe parents should stay
        firmly in control. That’s why we back the platform with practical content, clear guides, tips, and responsive
        customer support - giving families confidence to make the right choices for their own care.
        <br /><br />

      </p>
    </div>
    <!-- Toggle Buttons -->
    <div class="toggle-buttons">
      <button :class="{ active: currentRole === 'families' }" @click="currentRole = 'families'">
        For Families
      </button>
      <button :class="{ active: currentRole === 'nannies' }" @click="currentRole = 'nannies'">
        For NannyGrannies
      </button>
    </div>

    <!-- Video Grid -->
    <div class="video-grid">
      <div class="video-card" v-for="(video, index) in filteredVideos" :key="index">
        <div class="video-box">
          <!-- Show unlocked video with click handler -->
          <div v-if="!video.locked" class="unlocked-video" @click="playVideo(video.url)">
            <iframe :src="video.url" frameborder="0"></iframe>
            <div class="video-overlay">
              <div class="play-button">▶</div>
            </div>
          </div>




          <!-- <div v-if="!video.locked" class="video-player-wrapper">
            <iframe v-if="!video.locked" :src="video.url" frameborder="0" allowfullscreen></iframe>
          </div> -->


          <!-- Locked video overlay -->
          <div v-else class="locked-video" @click="handleLockedClick">
            <!-- Blurred background video -->
            <iframe class="background-video" :src="video.url" frameborder="0"></iframe>
            <div class="locked-overlay">

              <p v-if="!user">
                Login to access.<br />
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
                  <!-- Lock Body -->
                  <rect x="6" y="16" width="20" height="20" rx="3" ry="3" fill="black" stroke="none" />

                  <!-- Lock Shackle -->
                  <path d="M10 16V10a6 6 0 0 1 12 0v6" stroke="black" stroke-width="3" fill="none"
                    stroke-linecap="round" />

                  <!-- White Keyhole -->
                  <g fill="white">
                    <!-- Keyhole circle -->
                    <circle cx="16" cy="23" r="2" />
                    <!-- Keyhole slot -->
                    <rect x="14.5" y="22.5" width="3" height="7" rx="1.5" />
                  </g>
                </svg>

              </p>
              <p v-else-if="currentRole === 'families'">
                Upgrade to access<br />
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
                  <!-- Lock Body -->
                  <rect x="6" y="16" width="20" height="20" rx="3" ry="3" fill="black" stroke="none" />

                  <!-- Lock Shackle -->
                  <path d="M10 16V10a6 6 0 0 1 12 0v6" stroke="black" stroke-width="2.5" fill="none"
                    stroke-linecap="round" />

                  <!-- White Keyhole -->
                  <g fill="white">
                    <!-- Keyhole circle -->
                    <circle cx="16" cy="23" r="3" />
                    <!-- Keyhole slot -->
                    <rect x="14.5" y="22.5" width="3" height="7" rx="1.5" />
                  </g>
                </svg>

              </p>

              <p v-else-if="currentRole === 'nannies'">
                Complete your profile to access.<br />
                <svg xmlns="http://www.w3.org/2000/svg" width="32" height="40" viewBox="0 0 32 40" fill="none">
                  <!-- Lock Body -->
                  <rect x="6" y="16" width="20" height="20" rx="3" ry="3" fill="black" stroke="none" />

                  <!-- Lock Shackle -->
                  <path d="M10 16V10a6 6 0 0 1 12 0v6" stroke="black" stroke-width="2.5" fill="none"
                    stroke-linecap="round" />

                  <!-- White Keyhole -->
                  <g fill="white">
                    <!-- Keyhole circle -->
                    <circle cx="16" cy="23" r="3" />
                    <!-- Keyhole slot -->
                    <rect x="14.5" y="22.5" width="3" height="7" rx="1.5" />
                  </g>
                </svg>

              </p>

            </div>
          </div>
        </div>

        <!-- Video title -->
        <div class="video-title">
          {{ video.title }}
        </div>
      </div>
    </div>


    <!-- Help Section -->
    <div class="help-section">
      <span><strong>Still have</strong> <span class="red">questions?</span></span>
      <a href="/faqs">Click here</a>
    </div>

    <!-- Snackbar -->
    <!-- <v-snackbar v-model="snackbar.visible" :timeout="snackbar.timeout" bottom right multi-line>
      <div class="snackbar-box">
        <span v-html="snackbar.message" />
      </div>
    </v-snackbar> -->


    <v-snackbar :timeout="snackbarTimeout" :color="snackbarColor" right v-model="snackbarShow" :multi-line="false">
      <!-- Main Message (HTML supported) -->
      <h4 class="snackbar-style" v-html="snackbarText"></h4>

      <!-- Subtext below the message -->
      <p class="ma-0">{{ snackbarSubtext }}</p>

      <!-- Close button on right side -->
      <v-btn dark flat @click.native="close">
        <app-svg-icon name="ui/NG_CLOSE" width="14px" height="14px" />
      </v-btn>
    </v-snackbar>

    <!-- Video Modal -->
    <div v-if="showModal" class="modal-overlay" @click.self="closeModal">
      <div class="modal-content">
        <div class="video-loader" v-if="isLoading">
          <!-- <img src="/spinner.gif" alt="Loading..." width="50" /> -->
        </div>
        <iframe v-show="!isLoading" :src="modalVideoUrl" loading="lazy" width="100%" height="100%" frameborder="0"
          allow="autoplay; encrypted-media" allowfullscreen @load="onVideoLoad"></iframe>
        <button class="close-button" @click="closeModal">&times;</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'AppVideoLibrary',
  data() {
    return {
      user: null,
      currentRole: 'families',
      showModal: false,
      modalVideoUrl: '',
      isLoading: true,
      snackbar: {
        visible: false,
        message: '',
        timeout: 4000
      },
      snackbarText: '',
      snackbarSubtext: '',
      snackbarShow: false,
      snackbarTimeout: 4000,
      snackbarColor: 'info',
      videos: {
        families: [
          {
            id: 1,
            url: 'https://drive.google.com/file/d/1zKiosA_12dlMa5WSAMFJ3M5c3q_R-ps_/preview',
            locked: false,
            title: "How to Register as a Full Member",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Register+as+a+Full+Member.png"
          },
          {
            id: 2,
            url: 'https://drive.google.com/file/d/11vuuoC7i9CIGDiy76Owwsvb9pXahpSLu/preview',
            locked: false,
            title: "Unsubscribe or Subscribe to NannyGranny Newsletters.",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/Unsubscribe+or+Subscribe+to+NannyGranny+Newsletters.png"
          },
          {
            id: 3,
            url: 'https://drive.google.com/file/d/1EwnXVaEbmoZpdxPcatSJ__Y6FandPlIN/preview',
            locked: true,
            title: "How to Find a Nanny",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Find+a+Nanny.png"
          },
          {
            id: 4,
            url: 'https://drive.google.com/file/d/1b67lmsuEe_qiS9vf1Yp7__u6AAOqR4VW/preview',
            locked: true,
            title: "How to Post a Job",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Apply+for+a+Job.png"
          },
          {
            id: 5,
            url: 'https://drive.google.com/file/d/1FjUONkQuQPwJHFEpb0wVARwILLUQLhrx/preview',
            locked: true,
            title: "How to Check and Respond  to Messages",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Check+and+Respond+to+Messages.png"
          },
          {
            id: 6,
            url: 'https://drive.google.com/file/d/1HAygQnZ88-YyUrEJuCOu1Wf1MpxXzTQB/preview',
            locked: true,
            title: "How To Delete an Account",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          },
          {
            id: 7,
            url: 'https://drive.google.com/file/d/1wURfRojFqGnU9Rv5lmoDfCBJRwMyPN-g/preview',
            locked: false,
            title: "How to favourite Clubhouse articles",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          },
          {
            id: 8,
            url: 'https://drive.google.com/file/d/1RixMshc9Iz3_d6UBDEKC_R_kLqPcsBHs/preview',
            locked: false,
            title: "How to upgrade to Full Membership",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          },
          {
            id: 9,
            url: 'https://drive.google.com/file/d/1RixMshc9Iz3_d6UBDEKC_R_kLqPcsBHs/preview',
            locked: false,
            title: "How to Save and View NannyGrannies as Favourites",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          }
        ],
        nannies: [
          {
            id: 1,
            url: 'https://drive.google.com/file/d/11vuuoC7i9CIGDiy76Owwsvb9pXahpSLu/preview',
            locked: false,
            title: "Unsubscribe or Subscribe to NannyGranny Newsletters",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/Unsubscribe+or+Subscribe+to+NannyGranny+Newsletters.png"
          },
          {
            id: 2,
            url: 'https://drive.google.com/file/d/1g6R_QQvmiQ5U_MMCec7jzdOSL7OjkKcf/preview',
            locked: false,
            title: "How To Register as a Nanny",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Register+as+a+Nanny.png"
          },
          {
            id: 3,
            url: 'https://drive.google.com/file/d/1K55T7fQhx88qvAR4uaziLcoAJ3fqCwcl/preview',
            locked: true,
            title: "How To Edit Profile",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Edit+Profile.png"
          },
          {
            id: 4,
            url: 'https://drive.google.com/file/d/1KGeSJOldTMW3nhJ7lfQ40cBVAY4B4eCS/preview',
            locked: true,
            title: "How To Apply for a Job",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Apply+for+a+Job.png"
          },
          {
            id: 5,
            url: 'https://drive.google.com/file/d/1FjUONkQuQPwJHFEpb0wVARwILLUQLhrx/preview',
            locked: true,
            title: "How to Check and Respond to Messages",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+to+Check+and+Respond+to+Messages.png"
          },
          {
            id: 6,
            url: 'https://drive.google.com/file/d/1HAygQnZ88-YyUrEJuCOu1Wf1MpxXzTQB/preview',
            locked: true,
            title: "How To Delete an Account",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          },
          {
            id: 7,
            url: 'https://drive.google.com/file/d/1wURfRojFqGnU9Rv5lmoDfCBJRwMyPN-g/preview',
            locked: false,
            title: "How to favourite Clubhouse articles",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          },
          {
            id: 8,
            url: 'https://drive.google.com/file/d/1vXwY3zl6OAXf62bP7yG4kNyE3VDkrFET/preview',
            locked: false,
            title: "How to Favourite Jobs",
            thumbnail: "https://nannygranny-prod.s3.ap-southeast-2.amazonaws.com/How+To+Delete+an+Account.png"
          }
        ]
      }
    };
  },

  computed: {
    filteredVideos() {
      return this.videos[this.currentRole];
    }
  },
  methods: {
    playVideo(url) {
      this.isLoading = true;
      this.showModal = true;
      setTimeout(() => {
        this.modalVideoUrl = url;
      }, 300);
    },
    closeModal() {
      this.showModal = false;
      this.modalVideoUrl = '';
      this.isLoading = true;
    },
    onVideoLoad() {
      this.isLoading = false;
    },
    handleLockedClick() {
      const token = localStorage.getItem('_token');
      const userRaw = localStorage.getItem('auth._user');
      const user = userRaw ? JSON.parse(userRaw) : null;

      if (!token || !user) {
        this.showSnackBar('Please <a href="/login" style="color: white; text-decoration: underline;">log in</a> or register to access this content.', 'error');
        this.$router.push('/login');
        return;
      }

      const isNanny = user.role === 'nanny';
      const isParent = user.role === 'parent';
      const isProfileComplete = user.is_jobprofilevisible === 1;
      const isSubscribed = user.subscription && user.subscription.active === true;

      if (isNanny) {
        if (isProfileComplete) {
          this.showSnackBar(
            this.currentRole === 'nannies'
              ? 'This content is for Nannies only. You can find content for Families under the For Families section.'
              : 'This content is for Families only. You can find content for Nannies under the For NannyGrannies section.',
            'error'
          );
        } else {
          this.showSnackBar(
            this.currentRole === 'nannies'
              ? 'Please complete your <a href="/profile" style="color: white; text-decoration: underline;">profile</a> in order to access NannyGranny content.'
              : 'This content is for Families only. You can find content for Nannies under the For NannyGrannies section.',
            'error'
          );
        }
        return;
      }

      if (isParent) {
        if (isSubscribed) {
          this.showSnackBar(
            this.currentRole === 'families'
              ? 'This content is for Families only. You can find content for Nannies under the For NannyGrannies section.'
              : 'This content is for Nannies only. You can find content for Families under the For Families section.',
            'error'
          );
        } else {
          if (this.currentRole === 'families') {
            this.$router.push('/subscription');
          } else {
            this.showSnackBar(
              'This content is for Nannies only. You can find content for Families under the For Families section.',
              'error'
            );
          }
        }
      }
    },
    showSnackBar(message, color = 'info', timeout = 4000, subtext = '') {
      this.snackbarText = message;
      this.snackbarColor = color;
      this.snackbarTimeout = timeout;
      this.snackbarSubtext = subtext;
      this.snackbarShow = true;
    },
    close() {
      this.snackbarShow = false;
    }
  },
  mounted() {
    const token = localStorage.getItem('_token');
    const userRaw = localStorage.getItem('auth._user');
    const user = userRaw ? JSON.parse(userRaw) : null;
    this.user = user;
    if (!token || !user) {
      this.currentRole = 'families';
      return;
    }

    if (token && user) {
      if (user.role === 'nanny') {
        this.currentRole = 'nannies';
        if (user.is_jobprofilevisible === 1) {
          this.videos.nannies = this.videos.nannies.map(video => ({ ...video, locked: false }));
        }
      } else if (user.role === 'parent') {
        this.currentRole = 'families';
        if (user.subscription && user.subscription.active === true) {
          this.videos.families = this.videos.families.map(video => ({ ...video, locked: false }));
        }
      }
    }
  }
};
</script>


<style scoped>
.banner-text-box {
  width: 70%;
  /* jitna chahiye utna width do */
  margin: 0 auto;
  /* left-right se auto margin dega aur center karega */
}

.video-library {
  background: #f1f8f7;
  padding: 30px 20px;
  text-align: center;
}

.toggle-buttons {
  display: flex;
  justify-content: center;
  margin-bottom: 30px;
  flex-wrap: wrap;
  gap: 10px;
}

.video-title {
  white-space: normal;
  word-wrap: break-word;
  overflow-wrap: break-word;
  text-align: center;
  font-size: 18px;
  line-height: 1.4;
}

.toggle-buttons button {
  background: #e0e0e0;
  color: #555;
  padding: 10px 20px;
  border-radius: 20px;
  border: none;
  font-weight: bold;
  cursor: pointer;
  transition: 0.3s;
}

.toggle-buttons button.active {
  background: #2563eb;
  color: white;
}

.video-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(220px, 1fr));
  gap: 25px;
  justify-items: center;
  margin: 30px auto;
  max-width: 1080px;
}

.video-card {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.video-box {
  position: relative;
  width: 220px;
  height: 130px;
  background: #ddd;
  border-radius: 8px;
  overflow: hidden;
}

.video-box iframe {
  width: 100%;
  height: 100%;
  border: none;
}

.unlocked-video {
  position: relative;
  width: 100%;
  height: 100%;
  cursor: pointer;
}

.unlocked-video iframe {
  width: 100%;
  height: 100%;
  border: none;
  pointer-events: none;
}

.video-overlay {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.3);
  z-index: 1;
  display: flex;
  justify-content: center;
  align-items: center;
  opacity: 0;
  transition: opacity 0.3s ease;
}

.unlocked-video:hover .video-overlay {
  opacity: 1;
}

.play-button {
  background: rgba(255, 255, 255, 0.9);
  color: #333;
  border-radius: 50%;
  width: 50px;
  height: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  font-weight: bold;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.3);
}

.video-thumbnail {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.video-thumbnail-wrapper {
  position: relative;
  cursor: pointer;
  width: 100%;
  height: 100%;
}

.play-icon {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  font-size: 36px;
  color: white;
  background: rgba(0, 0, 0, 0.5);
  padding: 8px 14px;
  border-radius: 50%;
}

.locked-video {
  width: 100%;
  height: 100%;
  position: relative;
  cursor: pointer;
}

.background-video {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  filter: blur(12px);
  -webkit-filter: blur(12px);
  pointer-events: none;
  z-index: 1;
}

.locked-overlay {
  position: absolute;
  inset: 0;
  backdrop-filter: blur(5px);
  -webkit-backdrop-filter: blur(5px);
  color: white;
  font-size: 13px;
  font-weight: 500;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  padding: 15px;
  line-height: 1.5;
  z-index: 2;
}

.locked-overlay p {
  margin-top: 18px;
  color: black;
  font-weight: 900;
  /* Extra bold */
  font-size: 18px;
  /* Text ko thoda bada kar diya */
}

.help-section {
  margin-top: 40px;
  font-size: 15px;
}

.help-section .red {
  color: red;
}

.help-section a {
  color: #2563eb;
  font-weight: bold;
  margin-left: 5px;
}



.snackbar-box {
  background-color: orange !important;
  color: white;
  padding: 14px 20px;
  border-radius: 8px;
  font-size: 14px;
  font-weight: 400;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.2);
  line-height: 1.5;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(255, 255, 255, 0.4);
  /* Light + transparent */
  backdrop-filter: blur(6px);
  /* Blur effect */
  -webkit-backdrop-filter: blur(10px);
  /* Safari support */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  position: relative;
  width: 90%;
  max-width: 800px;
  height: 450px;
  /* background: #000; */
  border-radius: 8px;
  overflow: hidden;
}

.video-loader {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  color: white;
  font-size: 18px;
  font-weight: bold;
}

.close-button {
  position: absolute;
  top: 45px;
  right: 15px;
  background: transparent;
  border: none;
  font-size: 28px;
  color: black;
  cursor: pointer;
  z-index: 1001;
}
</style>


// WEBPACK FOOTER //
// src/components/how-it-works-components/AppVideoLibrary.vue